import { useNavigate } from 'react-router-dom';
import CreateFavored from '../withdrawals/components/CreateFavored';

export default function PixFavoredPage() {
  const navigate = useNavigate();
  return <CreateFavored onClose={() => navigate('/access/saques')} asPage />;
}
